import { Injectable } from '@angular/core';
import { LogLevel } from '../enums/log-level.enum';
import { LogEntry } from '../models/logEntry.model';

@Injectable({
  providedIn: 'root',
})

/**
 * Class that manages web service logs
 */
export class LogService {
  constructor() {}

  logEntry: LogEntry = {
    entryDate: new Date(),
    message: '',
    level: LogLevel.All,
  };

  /**
   * Creates a new log message and displays it on the console.
   * Resets the Log Entry.
   * @param {any} msg: Message that will show up on the logger
   * @param {LogLevel} level: Log level of the message that will be shown
   */
  log(msg: any, level: LogLevel) {
    this.logEntry.message = msg;
    this.logEntry.level = level;
    this.logEntry.entryDate = new Date();
    if (level === 4) {
      console.error(JSON.stringify(this.logEntry));
    } else {
      console.log(JSON.stringify(this.logEntry));
    }
    this.resetLogEntry();
  }

  /**
   * Logs error messages into the console.
   * Resets the Log Entry.
   * @param {any} msg: Error message that will be displayed
   * @param {LogLevel} level: Log level of the error message, it can only be 4 or 5
   */
  logError(msg: any, level: LogLevel) {
    this.logEntry.message = msg.message;
    this.logEntry.level = level;
    this.logEntry.entryDate = new Date();
    this.logEntry.status = msg.status;
    this.logEntry.extraInfo = msg.extraInfo;
    this.logEntry.service = msg.service;
    console.error(this.logEntry);
    this.resetLogEntry();
    console.log('ERROR');
  }

  /**
   * Calls log method for debug level
   * @param msg: Debug message
   */
  debug(msg: string) {
    this.log(msg, LogLevel.Debug);
  }

  /**
   * Calls log method for error level
   * @param msg: error message
   */
  error(msg: any) {
    this.logError(msg, LogLevel.Error);
  }

  /**
   * Calls log method for info level
   * @param msg: Info message
   */
  info(msg: any) {
    this.log(msg, LogLevel.Info);
  }

  /**
   * Calls log method for api Error level
   * @param msg: Error message
   */
  errorApi(msg: any) {
    this.log(msg, LogLevel.Error);
  }

  /**
   * Resets logEntry object to it's default values so that it can be used if we have multiple logs on one screen/petition.
   */
  resetLogEntry() {
    this.logEntry = {
      entryDate: new Date(),
      message: '',
      level: LogLevel.All,
      status: '',
      extraInfo: undefined,
      service: '',
    };
  }
}
